import snake from "../assets/AnimalHeads/snake.png"
import pig from "../assets/AnimalHeads/pig.png"
import rabbit from "../assets/AnimalHeads/rabbit.png"
import hippo from "../assets/AnimalHeads/hippo.png"
import giraffe from "../assets/AnimalHeads/giraffe.png"
import panda from "../assets/AnimalHeads/panda.png"
import elephant from "../assets/AnimalHeads/elephant.png"
import penguin from "../assets/AnimalHeads/penguin.png"
import monkey from "../assets/AnimalHeads/monkey.png"

export const ALL_ANIMAL_PICS = [
  
   
    snake,
    hippo,
    penguin,
    rabbit,
    monkey,
    panda,
    pig,
    giraffe,
    elephant,
    
]

export const ALL_ANIMAL_INFO = [
    {
        image: snake,
        name: "Snake",
        isFlipped: false,
        isMatched: false
    },
    {
        image: hippo,
        name: "Hippo",
        isFlipped: false,
        isMatched: false
    },
    {
        image: penguin,
        name: "Penguin",
        isFlipped: false,
        isMatched: false
    },
    {
        image: rabbit,
        name: "Rabbit",
        isFlipped: false,
        isMatched: false
    },
    {
        image: monkey,
        name: "Monkey",
        isFlipped: false,
        isMatched: false
    },
    {
        image: panda,
        name: "Panda",
        isFlipped: false,
        isMatched: false
    },

    {
        image: pig,
        name: "Pig",
        isFlipped: false,
        isMatched: false
    },

    {
        image: giraffe,
        name: "Giraffe",
        isFlipped: false,
        isMatched: false
    },
]